import React, { useEffect, useState } from "react";

interface CountdownTimerProps {
  targetDate: Date;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState<string>("00:00");

  const calculateTimeLeft = (targetDate: Date): string => {
    const now = new Date();
    const differenceInMillis = targetDate.getTime() - now.getTime();

    if (differenceInMillis <= 0) {
      return "00:00";
    }

    const totalSeconds = Math.floor(differenceInMillis / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  useEffect(() => {
    const updateTimer = () => {
      setTimeLeft(calculateTimeLeft(targetDate));
    };

    // Initial calculation
    updateTimer();

    // Update the timer every second
    const intervalId = setInterval(updateTimer, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [targetDate]);

  return <b>{timeLeft}</b>;
};

export default CountdownTimer;
